/**
 * `STEAM ↗` — the WHAT'S NEW card's link out to the store page.
 *
 * It was a 44px button in the YOUR CALL footer for one day. Marcus walked the
 * sheet on staging and it competed with the vote strip for the same attention
 * and pushed the band taller, so it became this: a compact 30px chip anchored
 * top-right of THE GAME band, on the ADDED BY row (DESIGN-CHANGELOG
 * 2026-08-25, both trees).
 *
 * Still framed rather than accent, for the reason the button was: green is the
 * call-to-action colour and this is not the call to action.
 *
 * `hover` is desktop-only, and deliberately: a hover style on a touch tree
 * sticks after the tap that opened the store page, so the chip would come back
 * looking pressed.
 */

import { useState } from 'react';

const MONO = 'var(--gt-font-mono)';

export function SteamChip({ href, hover = false }: { href: string; hover?: boolean }): JSX.Element {
  const [on, setOn] = useState(false);
  const lit = hover && on;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      {...(hover
        ? { onMouseEnter: () => setOn(true), onMouseLeave: () => setOn(false) }
        : {})}
      style={{
        display: 'flex',
        alignItems: 'center',
        flex: 'none',
        height: 30,
        boxSizing: 'border-box',
        border: '1px solid var(--gt-border-3)',
        background: lit ? 'var(--gt-border-2)' : 'var(--gt-card)',
        padding: '0 9px',
        fontFamily: MONO,
        fontSize: 9,
        letterSpacing: '.06em',
        color: lit ? 'var(--gt-text)' : 'var(--gt-text-2)',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      STEAM ↗
    </a>
  );
}
